var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * This method is used to check if the provided object is a Portkey provider.
 * @param provider - the object that need to be checked
 * @returns provider is IClient
 */
export function isPortkeyProvider(provider) {
    return !!(provider && typeof provider === 'object' && 'invokeClientMethod' in provider);
}
export function getPortkeyShellApp(timeout) {
    return __awaiter(this, void 0, void 0, function* () {
        if (typeof window === 'undefined')
            return null;
        const _window = window;
        if (_window.portkeyShellApp) {
            return isPortkeyProvider(_window.portkeyShellApp) ? _window.portkeyShellApp : null;
        }
        return new Promise(resolve => {
            const handlePortkey = () => {
                clearTimeout(timerId);
                if (isPortkeyProvider(_window.portkeyShellApp)) {
                    resolve(_window.portkeyShellApp);
                }
                else {
                    resolve(null);
                }
            };
            const timerId = setTimeout(() => {
                handlePortkey();
            }, timeout);
        });
    });
}
